import type { Directive } from "vue";

/**
 * Directive that extracts the first h1 from an element and moves it
 * to immediately before the element. Useful for applying surface
 * styling to content without including the main heading.
 *
 * Usage: <div v-extract-heading class="surface">...</div>
 */
export const vExtractHeading: Directive = {
  mounted(el: HTMLElement) {
    const h1 = el.querySelector("h1");
    if (h1 && el.parentNode) {
      el.parentNode.insertBefore(h1, el);
    }
  },
};
